module.exports = __webpack_public_path__ + "img/Capacitacao_Pratica_em_Emergencia.dd8f776c.jpg";